module.exports = __webpack_public_path__ + "static/media/arrow.ddfbdc47.svg";